require('../../modules/es6.math.sinh');
module.exports = require('../../modules/_core').Math.sinh;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/sinh.js
// module id = 1425
// module chunks = 2